exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-breadcrumb.el-breadcrumb[data-v-b50ef614] {\n  display: inline-block;\n  font-size: 0.072917rem;\n  line-height: 0.260417rem;\n  margin-left: 0.041667rem;\n}\n.app-breadcrumb.el-breadcrumb .no-redirect[data-v-b50ef614] {\n  color: #97a8be;\n  cursor: text;\n}", ""]);

// exports
